// ui/layouts/Card.tsx
import styled from "styled-components";

export const Card = styled.div`
  max-width: 480px;
  padding: ${({ theme }) => theme.spacing(3)};
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const CardFooter = styled.div`
  margin-top: ${({ theme }) => theme.spacing(3)};
  text-align: right;
`;